// src/components/invoices/InvoiceViewModal.jsx
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import InvoiceLayout from './InvoiceLayout';
import InvoiceSignatureButton from './InvoiceSignatureButton';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { IconDeviceMobile, IconDownload, IconPrinter, IconX } from '@tabler/icons-react';

const InvoiceViewModal = ({ facture, client, cabinetInfo, onClose, onDownloadPDF, onUpdateFacture }) => {
  const { eSignatureEnabled: tenantEsig, isCabinet, tenantType } = useAuth();
  const { workspaceESignatureEnabled } = useWorkspace();
  const eSignatureEnabled = isCabinet ? workspaceESignatureEnabled : tenantEsig;
  const invoiceRef = useRef();

  const handleDigiGoSign = () => {
    const AUTH_URL = "https://193.95.63.230/tunsign-proxy-webapp/oauth2/authorize";
    const CLIENT_ID = "10a77a2f-01aa-442c-8889-a4ec5fd25d79";
    const REDIRECT_URI = "https://app.accountintime.tn/digigo/callback";
    const USER_EMAIL = "admin@accountintime.tn";
    const invoiceId = facture.id || facture._id;
    if (!invoiceId) return;
    localStorage.setItem('pendingInvoiceId', invoiceId);
    const params = new URLSearchParams({ responseType: "code", clientId: CLIENT_ID, redirectUri: REDIRECT_URI, scope: "credential", credentialId: USER_EMAIL, numSignatures: 1, hash: "MTIzNDU2Nzg5MA==", state: invoiceId });
    window.location.href = `${AUTH_URL}?${params.toString()}`;
  };

  const handlePrint = () => {
    if (!invoiceRef.current) return;
    const printContent = invoiceRef.current.cloneNode(true);
    const printWindow = window.open('', '_blank', 'width=850,height=900');
    const titleLabel = tenantType === 'cabinet_medical' ? "Note d'honoraire" : 'Facture';
    printWindow.document.write(`<!DOCTYPE html><html><head><title>${titleLabel} ${facture?.number || ''}</title><meta charset="UTF-8"><style>body{margin:0;padding:0;font-family:sans-serif;background:white}</style></head><body>${printContent.outerHTML}</body></html>`);
    printWindow.document.close();
    printWindow.onload = () => { printWindow.focus(); printWindow.print(); setTimeout(() => printWindow.close(), 1000); };
  };

  if (!facture) return null;

  const isPending = !facture.eInvoicingStatus || facture.eInvoicingStatus === 'PENDING';

  return (
    <div className="fixed inset-0 bg-black/75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-6xl max-h-[95vh] overflow-hidden flex flex-col">

        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-200 bg-gray-50">
          <div>
            <h2 className="text-base font-semibold text-gray-800">{(tenantType === 'cabinet_medical' ? "Note d'honoraire" : 'Facture')} {facture.number || 'N/A'}</h2>
            <p className="text-gray-400 text-xs">Visualisation avant action</p>
          </div>
          <div className="flex items-center gap-2">
            {isPending && eSignatureEnabled && (
              <>
                <div><InvoiceSignatureButton facture={facture} onUpdateFacture={onUpdateFacture} /></div>
                <button onClick={handleDigiGoSign} title="Signer avec DigiGo"
                  className="inline-flex items-center gap-2 px-3 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-medium transition-colors">
                  <IconDeviceMobile size={15} strokeWidth={1.6} />
                  Signer DigiGo
                </button>
                <div className="h-6 w-px bg-gray-200 mx-1" />
              </>
            )}
            {onDownloadPDF && (
              <button onClick={() => onDownloadPDF(facture)}
                className="inline-flex items-center gap-2 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors">
                <IconDownload size={15} strokeWidth={1.6} />
                PDF
              </button>
            )}
            <button onClick={handlePrint}
              className="inline-flex items-center gap-2 px-3 py-2 bg-gray-700 hover:bg-gray-800 text-white rounded-lg text-sm font-medium transition-colors">
              <IconPrinter size={15} strokeWidth={1.6} />
              Imprimer
            </button>
            <button onClick={onClose} className="p-1.5 text-gray-400 hover:text-red-500 transition-colors ml-1">
              <IconX size={20} strokeWidth={1.6} />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6 bg-gray-100 flex justify-center">
          <div ref={invoiceRef} className="bg-white shadow-xl max-w-[210mm] w-full">
            <InvoiceLayout facture={facture} client={client} cabinetInfo={cabinetInfo} />
          </div>
        </div>
      </div>
    </div>
  );
};

InvoiceViewModal.propTypes = {
  facture: PropTypes.object.isRequired,
  client: PropTypes.object,
  cabinetInfo: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDownloadPDF: PropTypes.func,
  onUpdateFacture: PropTypes.func,
};

export default InvoiceViewModal;
